import React, { FC, ReactNode, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useServices } from "../../hooks/collections/useServices";
import { IService } from "../../@core/interfaces/IService";
import CarCard from "../../components/CarCard/CarCard";

export interface SectionGridFeaturePlacesProps {
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  gridClass = "",
  heading = "Featured services",
  subHeading = "Popular services we recommend for you.",
  headingIsCenter
}) => {
  const [featuredServices, setFeaturedServices] = useState<IService[]>([]);
  const [loading, setLoading] = useState(true);
  const { getFeaturedServices } = useServices();

  useEffect(() => {
    const loadFeaturedServices = async () => {
      try {
        const services = await getFeaturedServices(4);
        setFeaturedServices(services);
      } catch (error) {
        console.error("Error loading featured services:", error);
      } finally {
        setLoading(false);
      }
    };

    loadFeaturedServices();
  }, []);

  const renderCard = (service: IService) => {
    return <CarCard key={service.id} data={service}/>;
  };

  if (!loading && featuredServices.length === 0) return <></>

  return (
    <div className="nc-SectionGridFeaturePlaces relative px-4">
      <div className={`${headingIsCenter ? "text-center" : ""} mb-12`}>
        <h2 className="text-3xl font-semibold">{heading}</h2>
        <span className="mt-2 md:mt-3 font-normal block text-base sm:text-xl text-neutral-500 dark:text-neutral-400">
          {subHeading}
        </span>
      </div>
      <div
        className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
      >
        {!loading && featuredServices.length > 0 ? (
          featuredServices.map((service) => renderCard(service))
        ) : (
          <div className="col-span-4 text-center py-10">Loading featured services...</div>
        )}
      </div>
      <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary href={"/services"}>Show All <ArrowRightIcon className={"size-5 ms-2"}/></ButtonPrimary>
      </div>
    </div>
  );
};

export default SectionGridFeaturePlaces;
